//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateBreadcrumbSchema } from '~/utils/schema'

export default {
  name: 'ElementsBreadcrumbs',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: ''
    },
    right: {
      type: String,
      default: ''
    }
  },
  computed: {
    // Track locale so crumb URLs recompute when language changes
    currentLocale() {
      return (this.$i18n && this.$i18n.locale) || ''
    },
    crumbs() {
      // depend on locale
      void this.currentLocale

      const segments = (this.$route.path || '').split('/').filter(Boolean)
      const crumbs = []
      let path = ''
      const isEsports = segments[0] === 'e-sports'

      for (const raw of segments) {
        let segment = raw
        try {
          segment = decodeURIComponent(raw)
        } catch (_) {
          // keep raw if decoding fails
        }

        path += `/${raw}`
        const isValidRoute = !(isEsports && raw.toLowerCase() === 'match')

        crumbs.push({
          name: this.formatSegment(segment),
          url: this.localePath(path),
          isValidRoute
        })
      }

      return crumbs
    },
    // Avoid duplicating last segment when a title prop is provided
    crumbsForDisplay() {
      if (this.title && this.crumbs.length > 0) {
        return this.crumbs.slice(0, -1)
      }
      return this.crumbs
    },
    breadcrumbSchema() {
      if (!this.crumbs.length) return null

      const normalizedPath = (this.$route.path || '').replace(/\/+$/, '')
      if (normalizedPath.endsWith('/futbol')) {
        return null
      }

      const allCrumbs = [
        { name: this.$t('Home'), url: this.localePath('/') },
        ...this.crumbs
      ]

      // If a title is provided, reflect it as the last breadcrumb name
      if (this.title && allCrumbs.length) {
        const lastIdx = allCrumbs.length - 1
        allCrumbs[lastIdx] = {
          ...allCrumbs[lastIdx],
          name: this.title
        }
      }

      return generateBreadcrumbSchema(
        allCrumbs,
        this.$config.SEO_CANONICAL || `https://${this.$config.DOMAIN}`
      )
    }
  },
  methods: {
    formatSegment(segment) {
      return String(segment)
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
    },
    scrollToEnd() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const el = this.$refs.breadcrumbs
          if (el && el.scrollWidth > el.clientWidth) {
            if (typeof el.scrollTo === 'function') {
              el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' })
            } else {
              el.scrollLeft = el.scrollWidth
            }
          }
        })
      })
    }
  },
  head() {
    if (!this.breadcrumbSchema) return

    return {
      script: [
        {
          hid: 'breadcrumbs-jsonld',
          type: 'application/ld+json',
          json: this.breadcrumbSchema
        }
      ]
    }
  },
  watch: {
    '$route.path'() {
      this.scrollToEnd()
    },
    currentLocale() {
      this.scrollToEnd()
    }
  },
  mounted() {
    this.scrollToEnd()
  }
}
